<div class="about-us-view">
    <div class="about-us-content">
        <div class="about-us-header-content">
            <h1 class="header-text">About Us</h1>
            <p class="header-description">
                Simplify shared expenses and take the stress out of money
                management with
                our cutting-edge app. Streamline your finances, split costs, and
                gain valuable
                insights to optimize your spending.
            </p>
        </div>
        <div class="about-main">
            <h3 class="services-header-text">Our Serives</h3>
            <div class="services-content">
                <div class="service-list">Customizable expense groups for any
                    situation.</div>
                <div class="service-list">Seamless member addition and expense
                    tracking.</div>
                <div class="service-list">Automatic calculation and settlement
                    of shared costs.</div>
                <div class="service-list">Detailed expense reporting for
                    enhanced financial visibility.</div>
            </div>
        </div>
        <ccdl-card>
            <div class="contact-us-view">
                <h3 class="contact-header-text">Contact Us</h3>
                <div class="contact-us-content">
                    <div class="contact-us-name">
                        <ccdl-input
                            [labelName]="'First name'"
                            controlId="firstName"
                            [control]="getControl('firstName')"
                            [displayErrors]="isSubmitTriggered"
                            [errorConfig]="nameErrorConfig"></ccdl-input>
                        <ccdl-input
                            [labelName]="'Last name'"
                            controlId="lastName"
                            [control]="getControl('lastName')"
                            [displayErrors]="isSubmitTriggered"
                            [errorConfig]="nameErrorConfig"></ccdl-input>
                    </div>
                    <ccdl-input
                        [labelName]="'Email Address'"
                        controlId="emailId"
                        [control]="getControl('emailAddress')"
                        [displayErrors]="isSubmitTriggered"
                        [errorConfig]="emailErrorConfig"></ccdl-input>
                    <ccdl-single-select
                        [labelText]="'Country'"
                        [isDisabled]="false"
                        [placeHolder]="'Select country'"
                        [control]="getControl('countryCodeIso2')"
                        [options]="countryOptions"
                        [displayErrors]="isSubmitTriggered"
                        [errorConfig]="countryCodeErrorConfig"></ccdl-single-select>
                    <ccdl-text-area
                        [labelName]="'How can we help you?'"
                        controlId="helpYouId"
                        [control]="getControl('helpTextField')"
                        [displayErrors]="isSubmitTriggered"
                        [errorConfig]="helpErrorConfig"
                        [charLength]="3000"></ccdl-text-area>
                    <div class="about-us-website-input">
                        <ccdl-input
                            [labelName]="'Website'"
                            controlId="website"
                            [control]="getControl('website')"
                            [displayErrors]="false"></ccdl-input>
                    </div>
                    <ccdl-button [btnLabel]="'Submit'" [size]="'lg'"
                        [btnType]="'primary'"
                        (click)="onSubmitClick()"></ccdl-button>
                </div>
            </div>
        </ccdl-card>
    </div>
</div>
